<template>
  <div 
    class="follow-banner"
    data-sensors-exposure-event-name="Diversion_Exposure" 
    data-sensors-exposure-property-exposure_type="BANNER"
    :data-sensors-exposure-property-exposure_txt="banner.key"
    @click="showDialog"
  >
    <img :src="banner.content">
    <template v-if="banner.guidPageFlag==='Y'">
      <i class="finger2" v-if=" ['D'].includes(banner.key)"></i>
      <i class="finger1" v-else></i>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    banner: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    showDialog () {
      this.$sensors.track('Diversion_Click', {
        diversion_type: 'BANNER',
        diversion_txt: this.banner.key
      })
      if (this.banner?.guidPageFlag !== 'Y') return
      this.$emit('on-showDialog')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.follow-banner {
  width: 100%;
  position: relative;
  &>img {
    width: 100%;
  }
  .finger1 {
    width:40px;
    height:40px;
    position: absolute;
    background: url('./images/icon_shouzhi.png') no-repeat center;  
    background-size: 100% 100%;
    top: 50%;
    right: 55px;
    margin-top: -22px;
    animation: finger 0.3s infinite alternate;  
  }

  .finger2 {
    width:67px;
    height:54px;
    position: absolute;
    background: url('./images/img_shouzhi.png') no-repeat center;  
    background-size: 100% 100%;
    top: 50%;
    right: 55px;
    margin-top: -27px;
    animation: finger2 0.5s infinite alternate;  
  } 

  @keyframes finger {
    0% {
      transform: translateX(-5px);
    }
    100% {
      transform: translateX(15px);
    }
  }

  @keyframes finger2 {
    0% {
      transform: translateY(-5pY);
    }
    100% {
      transform: translateY(15px) scale(0.9);
    }
  }
}
</style>